import moment from "moment";
import { Calendar } from "primereact/calendar";
import { InputNumber } from "primereact/inputnumber";
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import { useState } from "react";

import "./style.scss";

const FIX = ({ handleUpdata, index, item }) => {
    const valueOutStart = item.dateStart ? moment(item.dateStart).toDate() : moment().toDate();
    const valueOutEnd = item.dateEnd ? moment(item.dateStart).toDate() : moment().toDate();

    const onChangeCalendar = (value, key) => {
        handleUpdata(index, { ...item, [key]: value });
    };

    const handleChangeValue = (value, key) => {
        handleUpdata(index, { ...item, [key]: value });
    };

    return (
        <div className="fix-block">
            <div className="block__input">
                <label>Комментарий к плейсменту*</label>
                <InputText placeholder="Укажите комментарий" value={item.comments} onChange={(e) => handleChangeValue(e.target.value, "comments")} />
            </div>

            <div className="block__input-switch">
                <label>Укажите диапазон ставки*</label>
                <div className="block__switch">
                    <InputSwitch checked={item.indefinitely} onChange={(e) => handleChangeValue(e.value, "indefinitely")} />
                    <label>Бессрочно</label>
                </div>
            </div>

            <div className="block__date">
                <div className={`date__item`}>
                    <label>Дата начала*</label>
                    <Calendar
                        mask={"99.99.9999"}
                        value={item.dateStart === "" ? valueOutStart : item.dateStart}
                        onChange={(e) => onChangeCalendar(e.value, "dateStart")}
                        dateFormat="dd.mm.yy"
                        placeholder="Выберите дату"
                        locale="rus"
                        timeOnly={false}
                    />
                </div>
                {!item.indefinitely ? (
                    <div className={`date__item`}>
                        <label>Дата окончания *</label>
                        <Calendar mask={"99.99.9999"} value={item.dateEnd === "" ? valueOutEnd : item.dateEnd} onChange={(e) => onChangeCalendar(e.value, "dateEnd")} dateFormat="dd.mm.yy" placeholder="Выберите дату" locale="rus" timeOnly={false} />
                    </div>
                ) : null}
            </div>

            <div className="block__input">
                <label>Стоимость с НДС*</label>
                <InputNumber placeholder="-" locale="ru-RU" mode="currency" currency="RUB" onChange={(e) => handleChangeValue(e.value, "priceWithNds")} />
                <span className="desc">{item.priceWithNds ? (item.priceWithNds / 1.2).toFixed(2) : "Здесь появится стоимость без НДС"}</span>
            </div>
        </div>
    );
};

export default FIX;
